<template>
  <div>
    <cards
      :id="order.client.id"
      @input="changeCard"
      v-model="order.card_id"
      :card="order.card"
    />

    <button @click="send" class="btn btn-info mw">
      {{ "next_step" | setText() }}
    </button>
  </div>
</template>
<script>
import { logger, errorNotify } from "../../../plugins/functions";
import ClientInfo from "@/components/Partners/ClientInfo";
export default {
  components: {
    Cards: () => import("@/components/Item/Order/Client/Cards"),
    ClientInfo,
  },
  props: {
    order: {
      default: function () {
        return {};
      },
    },
    transaction: {
      default: function () {
        return null;
      },
    },
    partner: {
      default: function () {
        return {};
      },
    },
    updateOrder: {
      default: function () {},
    },
    value: {
      default: function () {},
    },
    createTransaction: {
      default: function () {},
    },
  },
  async created() {},
  methods: {
    async changeCard(val) {
      await this.updateOrder({ card_id: val });
    },
    send() {
      if (!this.order.card_id || !this.order.card) {
        this.$notify({
          title: `!!!`,
          message: "Веберите карту в списке",
          icon: "ti-close",
          horizontalAlign: "right",
          verticalAlign: "top",
        });

        return false;
      }

      this.$emit("setStep", "purchases");

      logger(this.$http, {
        name: `Добавлена карта клиента`,
        description: "",
        model_type: "order",
        model_id: this.order.id,
      });
    },
  },
  data() {
    return {};
  },
};
</script>

